import { Injectable } from '@angular/core';
import { Lesson, LessonWithContextDetails } from '.';
import { School } from '../school';
import { Student } from '../student';
import { Router } from '@angular/router';
import { CardService, Card } from '../card';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Injectable()
export class LessonUtilService {
    public static readonly DEFAULT_BACKGROUND_COLOR = '9a8e8a';
    public static readonly LESSON_BEGINING_FIELD_NAME = 'begining';
    public static readonly CARD_ENDING_FIELD_NAME = 'validUntil';
    public static readonly maxLabelSizeForMobile = 15;

    public static getBackgroundColor(lesson: Lesson): string {
        return '#' +
            (lesson.classType && lesson.classType.backgroundColor ?
            lesson.classType.backgroundColor : LessonUtilService.DEFAULT_BACKGROUND_COLOR);
    }

    public static allowToPayOnline(school: School, lesson: Lesson, student: Student) {
        // It does not make sense to allow to pay online an student that does not belong to the given school
        if ((!school || !lesson || !student) ||
            (school.id !== student.schoolId) ||
            (!school.acceptOnlinePayments || !school.onlinePaymentsModuleEnabled) ||
            (!student.acceptOnlinePayments) ||
            (!lesson.classType || !lesson.classType.backOfficeUnitPriceId)
            ) {
            return false;
        }
        return true;
    }

    public static allowCurrentStudentToBook(currentUserIsStudent: boolean, lesson: LessonWithContextDetails) {
        const compatibleCards = lesson.currentStudentCompatibleCards;
        return currentUserIsStudent
        && ((compatibleCards && compatibleCards.length >= 1)
        || lesson.free);
    }

    public static allowCurrentStudentToCheckout(currentUserIsStudent: boolean, lesson: LessonWithContextDetails) {
         const compatibleCards = lesson.currentStudentCompatibleCards;
        return currentUserIsStudent
        && (!(compatibleCards && compatibleCards.length >= 1 )
        && !lesson.free);
    }

    public static getLabelForSmallDevices(value: string): string {
        return value && value.length > LessonUtilService.maxLabelSizeForMobile
                ? value.slice(0, LessonUtilService.maxLabelSizeForMobile) + '...'
                : value;
    }

    public static showPaymentMethodModal(router: Router, lessonId: number) {
         router.navigate(
                    ['/', { outlets: { popup: 'lesson/' + lessonId + '/choose-payment-method' } }],
                    { replaceUrl: true }
                );
    }

    public static handleBookClick(lesson: LessonWithContextDetails
                                    , cardService: CardService
                                    , createReservationOnLesson: (lesson: LessonWithContextDetails) => void
                                    , onError: (error: HttpErrorResponse) => void
                                    , router: Router): void {

        if (!lesson) {
            return;
        }

        if (lesson.free) {
            createReservationOnLesson(lesson);
            return;
        }

        // no cards on the same date for the given lesson, the user needs to select a payment method
        if (!lesson.currentStudentCompatibleCards || lesson.currentStudentCompatibleCards.length === 0) {
            LessonUtilService.showPaymentMethodModal(router, lesson.id);
            return;
        }

        const ids = lesson.currentStudentCompatibleCards
            .map(card => card.id)
            .join(' OR ');

        // cards in the same date of the lesson found, lets see if they have available places
        cardService
            .search({ query: `id:(${ids})` })
            .subscribe(
                (response: HttpResponse<Card[]>) => {
                    const cards = response.body || [];
                    const compatibleCards = cards.filter(
                        card => card.maxAssistancesNum > card.usedReservations
                    );

                    if (compatibleCards.length >= 1) {
                        createReservationOnLesson(lesson);
                    } else {
                        LessonUtilService.showPaymentMethodModal(router, lesson.id);
                    }
                },
                error => onError(error)
            );
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.util.service.ts